import { Link } from 'react-router-dom';

interface AsaHeroProps {
  tag: string;
  title: string;
  subtitle: string;
  description: string;
  buttonText: string;
  to: string;
}

export default function AsaHero({ tag, title, subtitle, description, buttonText, to }: AsaHeroProps) {
  return (
    <section className="relative pt-32 md:pt-40 pb-20 md:pb-28 px-4 md:px-6 overflow-hidden bg-[#0d0d1a]">
      <div
        className="blob w-[500px] h-[500px] top-0 right-0"
        style={{ background: 'linear-gradient(135deg, #7C3AED, #6D28D9)', opacity: 0.2 }}
      ></div>
      <div
        className="blob w-[400px] h-[400px] bottom-0 left-0"
        style={{ background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', opacity: 0.16, animationDelay: '-8s' }}
      ></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#1e1e3f] border border-[#3b3b6b]">
          <span className="w-2 h-2 rounded-full bg-[#a855f7]"></span>
          <span className="text-xs font-medium tracking-[0.22em] uppercase text-[#a78bfa]">{tag}</span>
        </div>
        <h1 className="mt-5 text-3xl md:text-5xl font-extrabold text-white leading-tight">{title}</h1>
        <p className="mt-4 text-lg md:text-xl font-semibold text-[#e8e8f0]">{subtitle}</p>
        <p className="mt-5 text-[#a0a0b0] text-base leading-relaxed max-w-2xl mx-auto">{description}</p>
        <div className="mt-8 flex justify-center">
          <Link
            to={to}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl h-12 px-8 text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#a855f7] text-white transition-all duration-300 hover:brightness-110 hover:scale-[1.02] hover:shadow-[0_14px_30px_rgba(124,58,237,0.4)]"
          >
            {buttonText}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}